import ReplayIcon from '@mui/icons-material/Replay';
import { Avatar, Tooltip, IconButton, CircularProgress, Typography } from '@mui/material';

export const excludedTableHeaders = (handleUndoExcludedPlaidTransaction, loadingRowId) => {
    return [
        {
            id: 'date',
            label: 'Date',
            sort: false,
        },
        {
            id: 'bank_account_name',
            label: 'Account Name',
            sort: false,
        },
        {
            id: 'description',
            label: 'Description',
            sort: false,
        },
        {
            id: 'amount',
            label: 'Total',
            sort: false,
            render: (row) => `${row.currency_code} ${row.amount}`,
        },
        {
            id: 'excluded_by',
            label: 'Excluded By',
            sort: false,
            render: (row) =>
                row?.email || row?.excluded_by_rule ? (
                    <Tooltip
                        title={
                            <Typography
                                textAlign="center"
                                fontSize="12px"
                                sx={{ textAlign: 'center' }}
                            >
                                {row?.email
                                    ? `${row.first_name} ${row.last_name}`
                                    : 'Excluded by rule'}
                            </Typography>
                        }
                    >
                        <Avatar sx={{ width: 30, height: 30 }}>
                            <Typography fontSize="12px">
                                {row?.email
                                    ? `${row.first_name[0].toUpperCase()}${row.last_name[0].toUpperCase()}`
                                    : 'R'}
                            </Typography>
                        </Avatar>
                    </Tooltip>
                ) : (
                    <Typography fontSize="12px">-</Typography>
                ),
        },
        {
            id: 'action',
            label: '',
            sort: false,
            render: (row) => (
                <IconButton
                    onClick={() => handleUndoExcludedPlaidTransaction(row)}
                    disabled={loadingRowId === row?.id}
                    sx={{ padding: 0 }}
                >
                    {loadingRowId === row?.id ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        <ReplayIcon fontSize="small" />
                    )}
                </IconButton>
            ),
        },
    ];
};
